import axios from "axios";

const actions = {
  // Fetch all custom role definitions for the current client.
  async getEmployeeRoleDefinitions({ commit }) {
    const res = await axios.get("employeeRole");

    const roles = res.data.data || res.data;

    commit("setEmployeeRoleDefinitions", roles);
    return roles;
  },

  // Create a new custom role definition, then refresh the cached list.
  async createEmployeeRoleDefinition({ dispatch }, payload) {
    const res = await axios.post("employeeRole", payload);
    await dispatch("getEmployeeRoleDefinitions");
    return res.data;
  },

  // Soft-delete a custom role definition, then refresh the cached list.
  async removeEmployeeRoleDefinition({ dispatch }, id) {
    const res = await axios.delete("employeeRole/" + id);
    await dispatch("getEmployeeRoleDefinitions");
    return res.data;
  },
};

export default actions;
